import { all, put, takeEvery, call, select } from "redux-saga/effects";
import { CATERING_OPTIONS_ACTIONS, CATERING_OPTIONS_TYPES } from "./actions";
import {
  getCateringOption as APIgetCateringOption,
  getCateringOptionPeriods as APIgetCateringOptionPeriods,
  getCateringOptions as APIgetCateringOptions,
  createCateringOption as APIcreateCateringOption,
  updateCateringOption as APIupdateCateringOption,
  deleteCateringOption as APIdeleteCateringOption,
  syncCateringPeriod as APIsyncCateringPeriod
} from "../../services/api/cateringOptions";
import { navigateTo } from "../navigation/saga";
import { cateringOptionsEvent, cateringOptionsFilters } from "./selectors";

export function* watchCateringOptionsActions() {
  yield all([
    takeEvery(CATERING_OPTIONS_TYPES.LOAD_ALL_REQUEST, getCateringOptions)
  ]);
  yield all([
    takeEvery(CATERING_OPTIONS_TYPES.LOAD_REQUEST, getCateringOption)
  ]);
  yield all([
    takeEvery(CATERING_OPTIONS_TYPES.CREATE_REQUEST, createCateringOption)
  ]);
  yield all([
    takeEvery(CATERING_OPTIONS_TYPES.UPDATE_REQUEST, updateCateringOption)
  ]);
  yield all([
    takeEvery(CATERING_OPTIONS_TYPES.DELETE_REQUEST, deleteCateringOption)
  ]);
  yield all([
    takeEvery(CATERING_OPTIONS_TYPES.CREATE_SUCCESS, getCateringOptions)
  ]);
  yield all([
    takeEvery(CATERING_OPTIONS_TYPES.DELETE_SUCCESS, getCateringOptions)
  ]);
}

function* getCateringOptions(action) {
  let { filters, eventId } = action.payload;

  try {
    if (filters) {
      yield put(CATERING_OPTIONS_ACTIONS.updateFilters(filters));
    } else {
      filters = yield select(cateringOptionsFilters);
    }

    eventId = yield call(checkEventId, eventId);

    const cateringOptions = yield call(APIgetCateringOptions, eventId, filters);
    yield put(CATERING_OPTIONS_ACTIONS.loadAllSuccess(cateringOptions));
  } catch (e) {
    yield put(CATERING_OPTIONS_ACTIONS.loadAllFailure(e));
  }
}

function* getCateringOption(action) {
  const { id } = action.payload;
  try {
    const eventId = yield call(checkEventId, action.payload.eventId);
    const cateringOption = yield call(APIgetCateringOption, eventId, id);
    const periods = yield call(APIgetCateringOptionPeriods, eventId, id);
    yield put(CATERING_OPTIONS_ACTIONS.loadSuccess(cateringOption, periods));
  } catch (e) {
    yield put(CATERING_OPTIONS_ACTIONS.loadFailure(e));
  }
}

function* createCateringOption(action) {
  const { values } = action.payload;
  try {
    const eventId = yield call(checkEventId, action.payload.eventId);
    const cateringOption = yield call(APIcreateCateringOption, eventId, values);
    yield call(APIsyncCateringPeriod, eventId, cateringOption.id, {
      periods: values.periods
    });
    yield put(CATERING_OPTIONS_ACTIONS.createSuccess(cateringOption));
    yield call(navigateTo, "/admin/events/" + values.eventId + "/catering");
  } catch (e) {
    yield put(CATERING_OPTIONS_ACTIONS.createFailure(e));
  }
}

function* updateCateringOption(action) {
  const { id, values } = action.payload;
  try {
    const eventId = yield call(checkEventId, action.payload.eventId);
    const cateringOption = yield call(
      APIupdateCateringOption,
      eventId,
      id,
      values
    );
    yield call(APIsyncCateringPeriod, eventId, id, { periods: values.periods });
    yield put(CATERING_OPTIONS_ACTIONS.updateSuccess(cateringOption));
    yield call(navigateTo, "/admin/events/" + values.eventId + "/catering");
  } catch (e) {
    yield put(CATERING_OPTIONS_ACTIONS.updateFailure(e));
  }
}

function* deleteCateringOption(action) {
  const { id } = action.payload;
  try {
    const eventId = yield call(checkEventId, action.payload.eventId);
    const cateringOption = yield call(APIdeleteCateringOption, eventId, id);
    yield put(CATERING_OPTIONS_ACTIONS.deleteSuccess(cateringOption));
  } catch (e) {
    yield put(CATERING_OPTIONS_ACTIONS.deleteFailure(e));
  }
}

function* checkEventId(eventId) {
  if (eventId) {
    yield put(CATERING_OPTIONS_ACTIONS.updateEvent(eventId));
  } else {
    eventId = yield select(cateringOptionsEvent);
  }

  return eventId;
}
